import styled from 'styled-components';

const ReadMoreButton = styled.button.attrs({ type: 'button' })`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  cursor: pointer;
  color: var(way-colors-contrastColorShades-80);
  font-size: 14px;
  line-height: 19px;
  text-decoration: underline;
`;

export default ReadMoreButton;
